import { createEntityAdapter } from '@reduxjs/toolkit';
import { TransportReservation } from '../models/transport-reservation.model';

const reservationAdapter = createEntityAdapter<TransportReservation>({
  selectId: (reservation) => reservation.reservationReferenceID,
});

export { reservationAdapter };
